import request from '../utils/request';

export async function getAfterSaleList(info, state, user, skip, take) {
  return await request(`shopBiz/servicelist?info=${info}&state=${state}&user=${user}&skip=${skip}&take=${take}`, 'get');
}